const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const getAuthHeaders = () => {
  const stored = localStorage.getItem('authTokens');
  const token = stored ? JSON.parse(stored).access_token : null;
  return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
};

export interface AcademyModule {
  id: string;
  title: string;
  category: string;
  order: number;
  completed: boolean;
  completed_at: string | null;
  unlocked: boolean;
}

export interface AcademyModulesResponse {
  modules: AcademyModule[];
  completed_count: number;
  total_count: number;
}

export interface AcademyProgress {
  completed_modules: string[];
  completed_count: number;
  total_count: number;
  progress_percent: number;
}

export const academyApi = {
  getModules: async (): Promise<AcademyModulesResponse> => {
    const res = await fetch(`${API_BASE_URL}/academy/modules`, { headers: getAuthHeaders() });
    if (!res.ok) throw new Error('Failed to fetch modules');
    return res.json();
  },

  completeModule: async (moduleId: string) => {
    const res = await fetch(`${API_BASE_URL}/academy/complete/${moduleId}`, {
      method: 'POST',
      headers: getAuthHeaders(),
    });
    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.detail || 'Failed to complete module');
    }
    return res.json();
  },

  getProgress: async (): Promise<AcademyProgress> => {
    const res = await fetch(`${API_BASE_URL}/academy/progress`, { headers: getAuthHeaders() });
    if (!res.ok) throw new Error('Failed to fetch progress');
    return res.json();
  },
};
